import * as React from 'react';
import {useEffect, useState, useRef, useCallback} from 'react';
// import fetch from 'node-fetch';
// import './app.css';
import {useTranslation} from 'react-i18next';
// @ts-ignore
import Vudio from 'vudio';
// @ts-ignore
import inclusive from './assets/images/inclusive.png';
// @ts-ignore
import media_play from './assets/images/media-play.png';
// @ts-ignore
import media_pause from './assets/images/media-pause.png';
import {
	Divider,
	List,
	ListItem, useTheme, CircularProgress
} from '@mui/material';
import PlayIcon from '@icons/PlayIcon';
import PauseIcon from '@icons/PauseIcon';
import {Link} from 'react-router-dom';
import {appConfig} from '@config';

type TStation = {
	'id': number,
	'name': string,
	'logo': string,
	'audio': string,
	'category': string,
	'tag': string,
	'isLocal': boolean,
	'isStream': boolean,
	'isHomePage': boolean
};

interface IProps {
	serverUrl?: string;
	pageUrl?: string;
}

const serverUrl = appConfig.radio.url;

function handleClick(url: string) {
	window.location.href = url;
}

const RadioBox = () => {
// const RadioBox = ({serverUrl = 'http://127.0.0.1:8000', pageUrl}: IProps) => {
	const theme = useTheme();
	// @ts-ignore
	const first = theme.palette.primary[400];
	// @ts-ignore
	const second = theme.palette.primary[600];
	const {t} = useTranslation();
	const [stations, setStations] = useState<{ [key: string]: TStation[] }>({});
	const [activeStations, setActiveStations] = useState<TStation[]>([]);
	const [stationLoaded, setStationLoaded] = useState(false);
	const refAudio = useRef<HTMLAudioElement>(null);
	const refCanvas = useRef<HTMLCanvasElement>(null);
	const [audio, setAudio] = useState(null);
	const [canvas, setCanvas] = useState(null);
	const [vudio, setVudio] = useState(null);
	const [isPlaying, setIsPlaying] = useState(false);
	const [isRadioLoaded, setIsRadioLoaded] = useState(false);
	const [isMute, setIsMute] = useState(false);
	const [audioContext, setAudioContext] = useState();
	
	const serverUrl = appConfig.radio.url;
	let audioSource: MediaElementAudioSourceNode;
	let analyser;
	let dataArray;
	useEffect(() => {
		setupStations().then((data: { [key: string]: TStation[] }) => {
			// @ts-ignore
			setStations(data);
			setupActiveStations(data).then((activeData) => {
				setActiveStations(activeData);
			});
		});
	}, []);
	
	function getTag(type: string) {
		let tags = {
			'stream': 'bg-green-300 text-black',
			'live': 'bg-blue-500 text-white',
			'shahadat': 'bg-black text-white',
			'default': 'bg-white text-black'
		};
		// @ts-ignore
		return tags[type] || tags['default'];
	}
	
	const setupActiveStations = async (data: { [key: string]: TStation[] }) => {
		let activeStationsList: TStation[] = [];
		try {
			Object.keys(data).map((station) => {
				Object.values(data[station]).map((value) => {
					if (value.isHomePage) {
						activeStationsList = [...activeStationsList, ...[value]];
					}
				});
			});
			return activeStationsList;
		} catch (err) {
		}
		return activeStationsList;
	};
	
	const setupStations = async () => {
		let response = [];
		try {
			response = await fetch(`${serverUrl}/stations`, {
				mode: 'cors'
				// headers: {
				// 	'Access-Control-Allow-Origin': '*'
				// }
			}).then(async (res) => {
				response = await res.json();
				setStationLoaded(true);
				return response;
			});
		} catch (err) {
			setStationLoaded(false);
			// set
		}
		return response;
	};
	
	function AudioDuration() {
		return (
			<div><img src={inclusive}/></div>
		);
	}
	
	useEffect(() => {
		const audioCtx = new AudioContext();
		// let audioObj = document.querySelector('#audio2');
		// let canvasObj = document.querySelector('#canvas2');
		const timer = setTimeout(() => {
			// let canvasObj = $('#canvas');
			// let audioObj = $('audio');
			let prettify = false;
			let audioObj = refAudio.current;
			let canvasObj = refCanvas.current;
			// @ts-ignore
			setAudio(audioObj);
			// @ts-ignore
			setCanvas(canvasObj);
			
			// dataArray = new Uint8Array(analyser.frequencyBinCount);
			if (typeof audioSource == undefined) {
				audioSource = audioCtx.createMediaElementSource(audioObj as HTMLMediaElement);
				analyser = audioCtx.createAnalyser();
				audioSource.connect(analyser);
				analyser.connect(audioCtx.destination);
				// @ts-ignore
				setAudioContext(audioCtx);
			}
			// audioObj.crossOrigin = 'anonymous';
			let colors = [
				[
					[0, '#f00'],
					[0.3, '#f00'],
					[0.3, '#f90'],
					[0.7, '#f90'],
					[0.7, '#ff0'],
					[1, '#ff0']
				],
				'#ff0',
				['#06f', '#09f', ' #0Cf', '#007aff'],
				['#fb6d6b', '#c10056', ' #a50053', '#51074b'],
				[
					[0, '#06f'],
					[0.5, '#06f'],
					[0.5, '#09f'],
					[1, '#09f']
				],
				[
					[1, 'rgba(48,192,132,0.8)'],
					[0.7, '#ff0'],
					[1, 'rgba(48,192,132,0.59)'],
					[0.7, '#f90'],
					[1, 'rgba(48,192,132,0.8)'],
					[1, '#ff0']
				]
			];
			// audioObj.current.crossOrigin = 'anonymous';
			if (stationLoaded) {
				let vudioObj = new Vudio(audioObj, canvasObj, {
					effect: 'waveform',
					accuracy: 128, // Accuracy, actually expressed as the number of waveform bars, range 16-16348, must be 2 to the Nth power
					// width: 250,
					height: 80,
					circlebar: {
						maxHeight: 40,
						fadeSide: true,
						particle: false,
						shadowBlur: 4,
						shadowColor: 'rgba(244,244,244,.5)'
						// coverImg: nuanchun
					},
					circlewave: {
						maxHeight: 20,
						minHeight: -5,
						width: 250,
						height: 100,
						spacing: 1,
						fadeSide: true,
						shadowBlur: 2,
						shadowColor: '#caa',
						// coverImg: `${serverUrl}/media/images/${stationPlayer?.logo}?${stationPlayer?.name}`,
						prettify: true,
						particle: true,
						maxParticle: 100,
						circleRadius: 50,
						showProgress: false
					},
					waveform: {
						maxHeight: 50,
						minHeight: 1,
						spacing: 1,
						shadowBlur: 0,
						shadowColor: 'rgba(7,85,228,0.93)',
						prettify: true,
						fadeSide: true,
						horizontalAlign: 'center',
						verticalAlign: 'middle',
						color: [
							[0, '#f00'],
							[0.3, '#f00'],
							[0.3, '#f90'],
							[0.7, '#f90'],
							[0.7, '#ff0'],
							[1, '#ff0']
						]
					},
					lighting: {
						lineWidth: 2,
						maxHeight: 140,
						maxSize: 8,
						dottify: true,
						fadeSide: true,
						prettify: true,
						// color: '#49f3f7',
						shadowBlur: 2,
						shadowColor: 'rgba(244,244,244,.5)',
						horizontalAlign: 'center',
						verticalAlign: 'middle',
						showProgress: true
					}
				});
				vudioObj.setOption({
					waveform: {
						color: colors[4],
						prettify: true
					},
					circlewave: {
						color: colors[2],
						prettify: true
					},
					circlebar: {
						color: [
							[1, 'rgba(48,192,132,0.8)'],
							[0.7, '#ff0'],
							[1, 'rgba(48,192,132,0.59)'],
							[0.7, '#f90'],
							[1, 'rgba(48,192,132,0.8)'],
							[1, '#ff0']
						],
						prettify: true
					},
					lighting: {
						color: colors[5]
					}
				});
				setVudio(vudioObj);
				// @ts-ignore
				// vudioObj.dance();
				// vudio.play();
				// @ts-ignore
				// audioObj.play();
				if (vudioObj) {
					// @ts-ignore
					vudioObj.dance();
				}
			}
		}, 1000);
		return () => {
			clearTimeout(timer);
		};
		
	}, [stationLoaded]);
	
	function myOnLoadedData() {
		setIsRadioLoaded(true);
	}
	
	function myOnProgress() {
		// console.log('prog');
	}
	
	const onPlayClick = useCallback(() => {
		// if (vudio && audio) {
		if (isPlaying) {
			//@ts-ignore
			// vudio.pause();
			//@ts-ignore
			audio.pause();
		} else {
			//@ts-ignore
			vudio.dance();
			//@ts-ignore
			audio.play();
		}
		setIsPlaying(!isPlaying);
		// const ctx = new (window.AudioContext)();
		// const osc = ctx.createOscillator();
		// osc.connect(ctx.destination);
		// ctx.resume();
		// console.log(ctx);
		// @ts-ignore
		// audio.play();
		// @ts-ignore
		// vudio.dance();
		// }
	}, [audio, vudio, isPlaying]);
	return (
		
		<div id="radio_box" className="flex flex-col mx-4">
			<div className="flex flex-row flex-nowrap justify-between items-center mb-2">
				<div>{t('radio.radio_razavi')}</div>
				{/*<Link to={'/radio'}>*/}
				{/*	<div className="text-blue-500 cursor-pointer">{t('radio.load_more')}</div>*/}
				{/*	/!*<div className="text-blue-500 cursor-pointer" onClick={() => handleClick('/radio')}>{t('radio.load_more')}</div>*!/*/}
				{/*</Link>*/}
			</div>
			<List sx={{borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : 'grey.800'}}
			      className="py-0 flex flex-col"
			      key={'radio_list'}>
				{stationLoaded && activeStations &&
					Object.values(activeStations).map((station: any, index: number) => {
							let audio = '';
							if (station?.isLocal) {
								audio = `${serverUrl}/media/sounds/${station?.audio}`;
							} else {
								audio = station?.audio;
							}
							return (
								<>
									<ListItem className="block rounded border mb-2 pb-4" alignItems="flex-start" key={`list_${index}`}>
										<div className="rounded py-0" style={{direction: 'ltr'}}>
											<div className="w-full flex flex-col flex-nowrap align-bottom start-1 pt-4 px-2">
												<div className="w-full flex flex-row justify-start items-center text-center">
													{
														station.tag ? (
															<span
																className={`text-sm rounded border ml-2 px-1 ${getTag(station.tag)}`}>
																						{t(`radio.${station.tag}`)}
																					</span>
														) : null
													}
												</div>
												<div
													className="w-full text-right text-sm"
													style={{direction: 'rtl'}}
												>{station?.name}
												</div>
											</div>
											<audio
												ref={refAudio}
												src={audio}
												preload="auto"
												crossOrigin="anonymous"
												onLoadedData={myOnLoadedData}
												onProgress={myOnProgress}
											></audio>
											<canvas ref={refCanvas} className="canvasWaveBox"></canvas>
											{
												!isRadioLoaded ? (
													<div className={`flex w-full h-full justify-center items-center absolute top-0`}>
														<CircularProgress color={'secondary'}/>
													</div>
												) : (
													<div onClick={onPlayClick} className="absolute bottom-0 right-0">
														{isPlaying ? <img src={media_pause} alt={'media_pause'}/> :
															<img src={media_play} alt={'media_play'}/>}
													</div>
												)
											}
										</div>
									</ListItem>
									{index < Object.keys(activeStations).length - 1 && <Divider key={`divider_${index}`}/>}
								</>
							);
						}
					)
				}
			</List>
		</div>
	);
};
export default RadioBox;
